// // import coOne from './cl-one.json';
// // import ioTenQuery from './io-tenantiquery';
// // import ioTenSelf from './io-tenant-self.json';
// import io1 from './io-mieterqualifizierung.json';
// import io2 from './io-mieterselbstauskunft.json';
// import io3 from './io-immo-ersteinschätzung.json';
// import io4 from './io-immobilien-dokumente.json';
// import io5 from './io-mrg-pruefung.json';

// import io6 from './io-einzelcoaching.json';

// import cl1 from './cl-ausschreibungsmanager.json';
// import cl2 from './cl-verkehrsunfall.json';
// import cl3 from './cl-aus.man-v2.json';
// import cl4 from './cl-nda_prüfung.json';
// import cl5 from './cl-rap_(done).json';
// import cl6 from './cl-rap_(how_to).json';

// // import bb1 from './bb1.json';

// export const templateList = [
//   io1,
//   io2,
//   io3,
//   io4,
//   io5,
//   io6,
//   cl1,
//   cl2,
//   cl3,
//   cl4,
//   cl5,
//   cl6,
//   // bb1,
//   // {
//   //   id: 'id-1',
//   //   title: 'Test Template',
//   //   // description: 'Test',
//   //   entries: [
//   //     {
//   //       key: 'qeustion',
//   //       type: 'boolean',
//   //       text: 'Test Question?',
//   //       required: true,
//   //       asked: false,
//   //     },
//   //     {
//   //       key: 'question_text',
//   //       type: 'text',
//   //       text: 'text Question?',
//   //       required: true,
//   //     },
//   //     {
//   //       key: 'asdasd',
//   //       type: 'text',
//   //       text: 'Text Prompt Question?',
//   //       required: true,
//   //     },
//   //     {
//   //       type: 'hint',
//   //       text: 'Example Note 1',
//   //       // required: true,
//   //     },
//   //     {
//   //       key: 'doc1',
//   //       type: 'document',
//   //       text: 'Doc1',
//   //       required: false,
//   //     },
//   //   ],
//   // },
//   // {
//   //   id: 'id-2',
//   //   title: ' Secont  Template',
//   //   // description: 'Test',
//   //   entries: [
//   //     {
//   //       key: 'note',
//   //       type: 'hint',
//   //       text: 'Example Note',
//   //       // required: true,
//   //     },
//   //     {
//   //       key: 'quest',
//   //       type: 'boolean',
//   //       text: 'Bool Question?',
//   //       required: true,
//   //     },
//   //     {
//   //       key: 'text',
//   //       type: 'text',
//   //       text: 'Text Question?',
//   //       required: true,
//   //     },
//   //   ],
//   // },
//   // {
//   //   id: 'id-32',
//   //   title: 'Test  Template',
//   //   // description: 'Test',
//   //   entries: [
//   //     {
//   //       key: 'note',
//   //       type: 'hint',
//   //       text: 'Immo Note',
//   //       // required: true,
//   //     },
//   //     {
//   //       key: 'q1',
//   //       type: 'text',
//   //       text: 'Immo Question1',
//   //       required: true,
//   //     },
//   //     {
//   //       key: 'doc',
//   //       type: 'document',
//   //       text: 'Text Question?',
//   //       required: true,
//   //     },
//   //     {
//   //       key: 'text',
//   //       type: 'text',
//   //       text: 'Immo Question',
//   //       required: true,
//   //     },
//   //     {
//   //       key: 'q2',
//   //       type: 'boolean',
//   //       text: 'Haben SIe ein Haustier?',
//   //       required: true,
//   //     },
//   //     // {e
//   //     //   type: 'document',
//   //     //   text: 'Text Question?',
//   //     //   required: true,
//   //     // },
//   //   ],
//   // },
//   // {
//   //   id: 'io-tenant-z',
//   //   title: 'Mieterqualifizierung',
//   //   scope: 'io',
//   //   // description: 'Test',
//   //   entries: ioTenQuery,
//   // },
//   // {
//   //   id: 'io-tenant-2',
//   //   title: ' Mieterselbstauskunft',
//   //   scope: 'io',
//   //   // description: 'Test',
//   //   entries: ioTenSelf,
//   // },
//   // {
//   //   id: 'id-cl-manager',
//   //   title: ' Ausschreibungsmanager',
//   //   scope: 'cortlex',
//   //   // description: 'Test',
//   //   entries: coOne,
//   // },
// ];
// // { id: 1, post_id: 0, author: 'Jane Doe', body: 'I agree' },


import immoox0 from './io-immobilien-dokumente.json';
import immoox1 from './io-einzelcoaching.json';
import immoox3 from './io-mrg-prüfung.json';
import immoox4 from './io-mieterqualifizierung.json';
import immoox5 from './io-mieterselbstauskunft.json';
import immoox6 from './io-immo-ersteinschätzung.json';
import cortlex7 from './cl-rechtscheck_kurz.json';
import cortlex9 from './cl-ausschreibungsmanager.json';
import cortlex10 from './cl-aus.man-v2.json';
import cortlex12 from './cl-verkehrsunfall.json';
import cortlex13 from './cl-nda_prüfung.json';
import cortlex14 from './cl-rap_(how_to).json';
import cortlex15 from './cl-rap_(done).json';
import cortlex16 from './cl-agb_verhandlung.json';

export const templateList = [immoox0,
immoox1,
immoox3,
immoox4,
immoox5,
immoox6,
cortlex7,
cortlex9,
cortlex10,
cortlex12,
cortlex13,
cortlex14,
cortlex15,
cortlex16]